import React, { useContext, useEffect, useState} from "react";
import "../styles/styles.css";
import Error from "./Error"
import EnvCtx from "../contexts/EnvCtx";
import { useTranslation } from 'react-i18next'
import cameraCntx from "../contexts/CameraCntx";

const SezioneA = () => {
    const { cciaa } = useContext(EnvCtx);
    const { t } = useTranslation();
    let chiaveSezione = "A";
    const [isOpen, setIsOpen] = useState(true);
    const {selectedMediazione, selectedIva, sezioneA, liteA, selectedLiteA, setSelectedLiteA, tipiSpesaA, listValoreA, setListValoreA, raccomandataValues,
        setRaccomandataValues, inputAColore, setInputAColore, totaleA, error, showErrorA, setShowErrorA, setShowErrorB, setShowErrorC, liteAdanger,
        setLiteAdanger, errorLiteApdf, setErrorLiteApdf, getLitiByCamera, getValoreSpesa, handleErrorClick, formatNumber,
        getDescrizioneByLingua, getSottoTitoloByLingua, getTestoSezioneByLingua, getDescrizioneLivelloByLingua } = useContext(cameraCntx);

    useEffect(() => {
        getLitiByCamera(chiaveSezione);
    }, [getLitiByCamera, chiaveSezione]);

    useEffect(() => {
        if (selectedLiteA) {
            const fetchData = async () => {
                let risultatiValori = await Promise.all(tipiSpesaA.map(async (tipo) => {
                    if (selectedLiteA.id) {
                        const valoreSpesa = await getValoreSpesa(selectedMediazione, selectedLiteA.id, chiaveSezione, tipo.chiave);
                        return {
                            tipo: tipo.chiave,
                            valore: {
                                conIva: parseFloat(valoreSpesa.conIva),
                                senzaIva: parseFloat(valoreSpesa.senzaIva)
                            },
                        };
                    }
                    return null;
                }));
                risultatiValori = risultatiValori.filter((risultato) => risultato !== null);
                setListValoreA(risultatiValori);
            };
            fetchData();
        }
    }, [selectedMediazione, selectedLiteA, chiaveSezione, tipiSpesaA, getValoreSpesa, setListValoreA]);


    if (!sezioneA) return null;

    const sottoTitolo = getSottoTitoloByLingua(sezioneA)?.trim();

    const testo = getTestoSezioneByLingua(sezioneA)?.trim();

    const toggleAccordion = () => {
        setIsOpen(!isOpen);
    };

    const handleNRaccomandataChange = (event, chiave) => {
        const newValue = event.target.value;
        setRaccomandataValues(prevValues => ({
            ...prevValues,
            [chiave]: newValue,
        }));
        setInputAColore(prevValues => ({
            ...prevValues,
            [chiave]: newValue > 0 ? "blue" : "inherit",
        }));
    };

    const handleSelectChange = (event) => {
        setSelectedLiteA(liteA.find(item => item.id === parseInt(event.target.value, 10)));
        setLiteAdanger(false);
        setShowErrorA(false);
        setShowErrorB(false);
        setShowErrorC(false);
        setErrorLiteApdf(false);
    };

    return (
        <div className="accordion sezione-accordion" id="accordionSezionA" style={{backgroundColor: cciaa ? cciaa.background_colore : ""}}>
            <div className="accordion-item">
                <h2 className="accordion-header">
                    <button
                        className={`accordion-button sezione-accordion-button custom-accordion-button ${
                            isOpen ? "" : "collapsed"
                        }`}
                        type="button"
                        onClick={toggleAccordion}
                        aria-expanded={isOpen ? "true" : "false"}
                        aria-controls="panelcollapseSezioneA"
                        style={{backgroundColor: cciaa ? cciaa.background_colore : ""}}
                    >
                        <span>{sezioneA.chiave}. {getDescrizioneByLingua(sezioneA)}</span>
                    </button>
                </h2>
                <div id="panelcollapseSezioneA" className={`accordion-collapse ${isOpen ? 'show' : ''} panel-blanc`}>
                    <div className={`accordionBody sezione-accordion-body`}>
                        <div>
                            <div className="col-8">
                                <div className="row">
                                    <div className="col-6"> <label className="sezione-label">{t("sezioneA.valore_controversia")}</label> </div>
                                    <div className="col-6"> {error && (showErrorA) && <Error errors={[error]} />} </div>
                                </div>
                            </div>
                            <div className="sezione-div-error">
                                <div className={`invisible_div ${!selectedMediazione ? 'select-error-calc' : ''}`} onClick={() => handleErrorClick(chiaveSezione)}></div>
                                {liteA ? (
                                    <select className={`form-select form-select-lg mb-3 sezione-select ${(liteAdanger || errorLiteApdf ) ? 'border-danger' : ''}`} aria-label="Default select" value={selectedLiteA ? selectedLiteA.id : ''} onChange={handleSelectChange} disabled={!selectedMediazione}>
                                        <option disabled value="">{t("sezioneA.select_message")}</option>
                                        {liteA && liteA.map((item, index) => (
                                            <option key={index} value={item.id}>{getDescrizioneLivelloByLingua(item)}</option>
                                        ))}
                                    </select>
                                ) : (
                                    <select className={`form-select form-select-lg mb-3 sezione-select ${(liteAdanger || errorLiteApdf ) ? 'border-danger' : ''}`} aria-label="Default select" onChange={handleSelectChange}>
                                        <option disabled selected>{t("sezioneA.select_message")}</option>
                                    </select>
                                )}
                            </div>
                        </div>
                        {testo ? (
                            <div>
                                <p className="sezione-p"> {testo}</p>
                            </div>
                        ) : null}

                        {tipiSpesaA && tipiSpesaA.map((tipo, index) => {
                            if (!/^raccomandata/.test(tipo.chiave)) {
                                return (
                                    <div key={index} className="row mb-1">
                                        <div className="col-md-9">
                                            <p className="sezione-italic">{getDescrizioneByLingua(tipo)}</p>
                                        </div>
                                        {selectedLiteA && listValoreA && (
                                            listValoreA.map((item, idx) => {
                                                if (tipo.chiave === item.tipo) {
                                                    return (
                                                        <div key={idx} className="col-md-3 d-flex align-items-center justify-content-right">
                                                            <span className="badge rounded-pill text-bg-light sezione-span">
                                                                <span className="con-iva">€ {selectedIva === "IVA_inclusa" ? formatNumber(item.valore.conIva) : formatNumber(item.valore.senzaIva)}</span>
                                                            </span>
                                                        </div>
                                                    );
                                                } else {
                                                    return null;
                                                }
                                            })
                                        )}
                                    </div>
                                );
                            }  else {
                                return (
                                    <div key={index} className="row mb-1">
                                        <div className="col-md-9 d-flex align-items-center">
                                            <span className="me-2 mb-3">N°</span>
                                            <div className="sezione-div-error">
                                                <div className={`invisible_div ${!selectedLiteA ? 'input-error-cal' : ''}`} onClick={() => handleErrorClick(chiaveSezione)}></div>
                                                <input
                                                    type="number"
                                                    className="input-sm-nbr sezione-input mb-3"
                                                    value={raccomandataValues[tipo.chiave] || 0}
                                                    style={{ color: inputAColore[tipo.chiave] }}
                                                    min="0"
                                                    data-unit="0"
                                                    data-gtm-form-interact-field-id="0"
                                                    onChange={(event) => handleNRaccomandataChange(event, tipo.chiave)}
                                                    disabled={!selectedLiteA}
                                                />
                                            </div>
                                            <p className="sezione-italic">{getDescrizioneByLingua(tipo)}</p>
                                        </div>
                                    {selectedLiteA && listValoreA && (
                                        listValoreA.map((item, idx) => {
                                            if (tipo.chiave === item.tipo) {
                                                const value = raccomandataValues[tipo.chiave] || 0;
                                                return (
                                                    <div key={idx} className="col-md-3 d-flex align-items-center justify-content-right">
                                                            <span className="badge rounded-pill text-bg-light sezione-span">
                                                                <span className="con-iva">€ {selectedIva === "IVA_inclusa" ? formatNumber(item.valore.conIva * value) : formatNumber(item.valore.senzaIva * value)}</span>
                                                            </span>
                                                    </div>
                                                );
                                                  } else { return null; }
                                              })
                                          )}
                                  </div>
                              )
                            }
                        })}
                        <div className="row mb-1">
                            <div className="col-md-9">
                                <p className="sezione-total">{t("sezioneA.totale")}</p>
                            </div>
                            {selectedLiteA && (
                                <div className="col-md-3 d-flex align-items-center justify-content-right">
                                    <span className="badge rounded-pill text-bg-light sezione-total">€ {formatNumber(totaleA)}</span>
                                </div>
                            )}
                        </div>

                        {sottoTitolo ? (
                            <div className="font-italic mt-2">
                                <p
                                    className="sezione-p"
                                    dangerouslySetInnerHTML={{ __html: sottoTitolo }}
                                />
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SezioneA;
